import React, { useEffect, useState } from 'react';
import styled, { useTheme, css } from 'styled-components';
import { handleDeepLFetch } from '~/api/helpers/handleDeepLFetch';
import Icon from '../../atoms/Icon';
import { mq } from '~/styles/grid';

const Wrapper = styled.div`
  cursor: pointer;
  background-color: ${(props) => props.theme.color.gray50};
  color: ${(props) => props.theme.color.primary800};
  padding: 5px 10px;
  display: grid;
  grid-template-columns: 10% 80% 10%;
  align-items: center;
  justify-items: center;
  position: relative;
  width: 260px;
  ${(props) =>
    props.hasBorder &&
    css`
      border: 2px solid ${props.theme.color.white500};
    `}

  @media (${mq.xs}) {
    width: 250px;
    margin-top: 10px;
  }
`;

const Select = styled.select`
  text-align: center;
  text-indent: ${({ isSafari }) => (isSafari ? '65px' : '0px')};
  cursor: pointer;
  color: ${(props) => props.theme.color.primary800};
  background-color: transparent;
  z-index: 5;
  width: 135%;
  height: 135%;
`;

const StyledIconAfter = styled(Icon)`
  transform: rotate(90deg);
`;

/**
 * @param {DeepLSwitcherProps} props
 * @returns {React.ReactElement} The rendered component
 */
const DeepLSwitcher = ({
  onChange,
  placeholder,
  hasBorder = false,
  language,
}) => {
  const theme = useTheme();
  const isEnableAutoTranslateByUser = theme.jobDetail.automaticTranslation;

  /** @type {[DeepLLanguage[], React.Dispatch<React.SetStateAction<DeepLLanguage[]>>]} */
  const [languages, setLanguages] = useState();

  const [isSafari, setIsSafari] = useState(false);

  /**
   * @async
   * @returns {Promise<void>}
   */
  const handleFetch = async () => {
    const deepLlanguages = await handleDeepLFetch({
      language,
    });
    if (deepLlanguages) {
      setLanguages(deepLlanguages);
    }
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    handleFetch();
    const navigatorSafari =
      typeof window !== 'undefined' &&
      window.navigator &&
      /^((?!chrome|android).)*safari/i.test(
        window.navigator.userAgent.toLowerCase(),
      );
    setIsSafari(navigatorSafari);
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  if (!isEnableAutoTranslateByUser) {
    return <></>;
  }

  return (
    <Wrapper hasBorder={hasBorder}>
      <Icon icon="TRANSLATION" />
      <Select
        id="deepl-select"
        name="deeplLangSwitcher"
        isSafari={isSafari}
        onChange={(e) => onChange(e.target.value)}
      >
        <option disabled selected>
          {placeholder}
        </option>
        {languages &&
          languages.length &&
          languages.map((l, idx) => {
            return (
              <option key={idx} value={l.language}>
                {l.name}
              </option>
            );
          })}
      </Select>
      <StyledIconAfter icon="ARROW_BOLD" />
    </Wrapper>
  );
};

export default DeepLSwitcher;
